import { render, staticRenderFns } from "./NotificationAccountBlocked.vue?vue&type=template&id=3cdc5fd9&scoped=true&lang=pug&"
import script from "./NotificationAccountBlocked.vue?vue&type=script&lang=js&"
export * from "./NotificationAccountBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc5fd9",
  null
  
)

export default component.exports